import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP } from './LegalPages';

export function SubprocessorsPage() {
  const { t } = useTranslation();

  const rows = [
    {
      vendor: t('subprocessors.ai_vendor_name', { defaultValue: 'AI gateway' }),
      purpose: t('subprocessors.openrouter_purpose'),
      location: t('subprocessors.openrouter_location'),
      data: t('subprocessors.openrouter_data'),
    },
    {
      vendor: 'Hetzner Cloud',
      purpose: t('subprocessors.hetzner_purpose'),
      location: t('subprocessors.hetzner_location'),
      data: t('subprocessors.hetzner_data'),
    },
    {
      vendor: 'Cloudflare',
      purpose: t('subprocessors.cloudflare_purpose'),
      location: t('subprocessors.cloudflare_location'),
      data: t('subprocessors.cloudflare_data'),
    },
    {
      vendor: 'Google',
      purpose: t('subprocessors.google_purpose'),
      location: t('subprocessors.google_location'),
      data: t('subprocessors.google_data'),
    },
    {
      vendor: 'Microsoft',
      purpose: t('subprocessors.microsoft_purpose'),
      location: t('subprocessors.microsoft_location'),
      data: t('subprocessors.microsoft_data'),
    },
    {
      vendor: 'Stripe',
      purpose: t('subprocessors.stripe_purpose'),
      location: t('subprocessors.stripe_location'),
      data: t('subprocessors.stripe_data'),
    },
    {
      vendor: 'Tesseract.js · Tessdata',
      purpose: t('subprocessors.tesseract_purpose'),
      location: t('subprocessors.tesseract_location'),
      data: t('subprocessors.tesseract_data'),
    },
    {
      vendor: 'TDB · 帝国データバンク',
      purpose: t('subprocessors.tdb_purpose'),
      location: t('subprocessors.tdb_location'),
      data: t('subprocessors.tdb_data'),
    },
  ];

  return (
    <LegalShell titleKey="subprocessors.title">
      <LegalLead>{t('subprocessors.lead')}</LegalLead>

      <div className="mt-6 overflow-x-auto border border-ink-200">
        <table className="w-full text-[13px] border-collapse">
          <thead>
            <tr className="bg-ink-50 border-b border-ink-200">
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('subprocessors.col_vendor')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('subprocessors.col_purpose')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('subprocessors.col_location')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('subprocessors.col_data')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.vendor} className="border-b border-ink-200 last:border-b-0 align-top">
                <td className="px-4 py-3 font-semibold text-ink-900">{r.vendor}</td>
                <td className="px-4 py-3 text-ink-700">{r.purpose}</td>
                <td className="px-4 py-3 text-ink-700">{r.location}</td>
                <td className="px-4 py-3 text-ink-700">{r.data}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <LegalH2>{t('subprocessors.none_title')}</LegalH2>
      <LegalP>{t('subprocessors.none_body')}</LegalP>

      <p className="mt-8 pt-6 border-t border-ink-200 text-xs uppercase tracking-wide text-ink-500">
        {t('subprocessors.notification_note')}
      </p>
    </LegalShell>
  );
}
